<template>
  <!-- ようこそ画面 -->
  <div id="Welcome">
    <!-- 上部余白 -->
    <div style="height: 10px" />

    <div style="margin-left: 50px; margin-right: 50px">
      <div class="notice title is-6">ようこそ</div>
      <b-input
        type="textarea"
        :value="welcome"
        class="box"
        style="text-align: left"
        :readonly="true"
      ></b-input>
    </div>

    <div style="margin-top: 50px; margin-left: 50px; margin-right: 50px">
      <div class="notice title is-6">お知らせ</div>
      <b-input
        type="textarea"
        v-model="notice"
        class="box"
        style="text-align: left"
        :readonly="true"
      ></b-input>
    </div>
  </div>
</template>

<script>
export default {
  name: "Welcome",

  data() {
    return {
      notice: "",
      isShowtAlert: false,
      welcome: null,
    };
  },

  methods: {
    getNotice: function () {
      var excuteApi = this.getNoticePOST;
      var successCallBack = this.getNoticeSuccess;
      var errorCallBack = this.getNoticeError;
      // WebAPI Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getNoticePOST: function (client) {
      return client.apis.apiCommon.getAnnouncementPOST({});
    },
    getNoticeSuccess: function (result) {
      this.notice = result.obj.information;
      if (!this.notice) {
        this.notice = "お知らせはありません。";
      }
      this.welcome = result.obj.welcome;
    },
    getNoticeError: function (result) {
      console.log(result);
      this.notice = "お知らせを取得できませんでした。";
    },
  },

  components: {},

  mounted: function () {
    this.getNotice();
  },
};
</script>

<style lang="scss">
.notice {
  padding: 0.25em 0 0.25em 0.75em;
  border-left: 6px solid #209cee;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/home/Welcome.vue